import Vue from 'vue'
import Router from 'vue-router'
import Home from './../components/Home.vue'
import TeacherLogin from './../components/TeacherLogin.vue'
import TeacherView from './../components/TeacherView.vue'
import CreateProject from './../components/CreateProject.vue'
import EditProject from './../components/EditProject.vue'
import StudentView from './../components/StudentView.vue'

Vue.use(Router)

export default new Router({
    routes: [
      { path: '/', component: Home },
      { path: '/login', component: TeacherLogin },
      { path: '/teacher', component: TeacherView },
      { path: '/createproject', component: CreateProject },
      { path: '/editproject/:id', component: EditProject },
      { path: '/:id', component: StudentView }
    ]
})
